export default __webpack_public_path__ + "static/media/icon-document-not-found.d7bf4e52.svg";